import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { CommonModule } from "@angular/common";
import { COOKIE_PREFIX } from "src/environments/environment";
import { API_URLS } from "../../../config/app.constants";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";
import { Utils } from "../../../shared/utils";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
})
export class ResetPasswordComponent implements OnInit {
  resetPassword: FormGroup;
  password = new FormControl("", [
    Validators.required,
    Validators.minLength(6),
    Validators.maxLength(20),
  ]);
  password_confirmation = new FormControl("", [Validators.required]);

  token: string;
  isReset = false;
  planDetails: any = [];
  submitted: boolean = false;
  showHidePassword: boolean = false;
  showHideConfirmPassword: boolean = false;

  constructor(
    private http: HttpinterceptorService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder
  ) {
    const token = localStorage.getItem(`${COOKIE_PREFIX}_token`);
    if (token) {
      this.router.navigate(["/"]);
    }
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.token = params["id"];
    });
    this.initializeResetUserValidation();
  }

  initializeResetUserValidation() {
    this.resetPassword = this.formBuilder.group(
      {
        password: this.password,
        password_confirmation: this.password_confirmation,
      },
      {
        validator: Utils.MustMatch("password", "password_confirmation"),
      }
    );
  }

  resetUserPassword() {
    this.submitted = true;
    if (this.resetPassword.valid) {
      this.isReset = true;
      this.resetPassword.value.token = this.token;
      this.http
        .post(API_URLS.RESET_USER, this.resetPassword.value, true)
        .subscribe(
          (res) => {
            this.submitted = false;
            this.isReset = false;
            if (res.code == 200 && res.type === "success") {
              this.router.navigate(["/login"]);
            } else {
              return false;
            }
          },
          (error) => {
            this.submitted = false;
            this.isReset = false;
          }
        );
    } else {
      return false;
    }
  }

  /**
   * This method is the show or hide reset-password
   * */
  passwordShowHide() {
    this.showHidePassword = !this.showHidePassword;
  }

  /**
   * This method is the show or hide reset-confirm-password
   * */
  confirmPasswordShowHide() {
    this.showHideConfirmPassword = !this.showHideConfirmPassword;
  }

  cancelReset() {
    this.router.navigate(["/"]);
  }
}
